// extracted by mini-css-extract-plugin
export var discard = "_4h-3";
export var muiTooltipTooltip = "_4h-5";
export var notificationBar = "_4h-2";
export var saveButtonHoverSlotWrapper = "_4h-4";
export var show = "_4h-1";
export var spacer = "_4h-0";